const getCurrentPosition = (onSuccess: PositionCallback, onError?: PositionErrorCallback, options?: PositionOptions) => {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
  } else {
    console.log('Geolocation services not available');
  }
};

export default getCurrentPosition;
